import { render, staticRenderFns } from "./ExpiredMessageIcon.vue?vue&type=template&id=02703896"
import script from "./ExpiredMessageIcon.vue?vue&type=script&lang=js"
export * from "./ExpiredMessageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports